import {Component, inject, Input, OnInit} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';

import {AcceptanceCheckboxConfig, LabelSegment,} from '../../../models/form-config.model';
import {ModalService} from '../../../../../services/modal/modal-service';
import {FormSnapshot} from '../../../models/form-config.model';
import {ContractPreviewModal} from '../../../../modals/contract-preview-modal/contract-preview-modal';

/**
 * AcceptanceFieldComponent — checkbox singola per consensi e accettazioni.
 *
 * Usato in due contesti:
 * 1. Dentro una categoria (via FieldRendererComponent, `type: 'acceptance'`)
 * 2. Fuori dall'accordion (via AcceptancesBlockComponent, accettazioni globali)
 *
 * Supporta:
 * - Label semplice (stringa)
 * - Label ricca con link intercalati (LabelSegment[])
 * - Stato required con asterisco e bordo rosso se non spuntata e touched
 */
@Component({
  selector: 'app-acceptance-field',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './acceptance-field.component.html',
  styleUrl: './acceptance-field.component.scss',
})
export class AcceptanceFieldComponent implements OnInit {
  /**
   * Config dell'accettazione.
   * Obbligatorio: passare o `acceptance` (caso globale / inside-category via FieldConfig.acceptance)
   */
  @Input({required: true}) acceptance!: AcceptanceCheckboxConfig;
  @Input({required: true}) control!: FormControl;
  @Input() snapshot: FormSnapshot = {};

  segments: LabelSegment[] = [];
  isSimpleLabel = false;
  uniqueId = '';

  private readonly modalService = inject(ModalService);

  ngOnInit(): void {
    this.uniqueId = `acceptance-${this.acceptance.key}-${Math.random().toString(36).slice(2, 7)}`;

    if (typeof this.acceptance.label === 'string') {
      this.isSimpleLabel = true;
      this.segments = [{text: this.acceptance.label}];
    }
    else {
      this.isSimpleLabel = false;
      this.segments = this.acceptance.label;
    }
  }

  openContractModal(event: MouseEvent, url: string): void {
    event.preventDefault();
    event.stopPropagation();
    this.modalService.openModal({
      component: ContractPreviewModal,
      inputs: {
        url,
        snapshot: this.snapshot,
      },
      onConfirm: () => {
        this.control.setValue(true);
        this.control.markAsTouched();
      }
    });
  }

  get showError(): boolean {
    return this.control.invalid && this.control.touched;
  }

  get isRequired(): boolean {
    return this.acceptance.required !== false;
  }
}
